import React, { useEffect, useState } from 'react';
import { map, get, filter, includes, split, isEmpty } from 'lodash';
import moment from 'moment';
import { bool, func, arrayOf, object, array, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import {
    FlexContainer,
    Icon,
    ConditionalRender,
    Text,
    FormDatePicker,
    InnerAside,
    InnerAsideContent,
    FormSelect,
    Button,
    Checkbox,
    MobileWrapper,
    CompanyGroupsSelect
} from '../../common';
import UserSearchSelect from '../Users/UserSearchSelect';
import { statusOptions, orderTypeOptions } from '../../../utils/misc';


const formatCategoryOptions = (data) => map(get(data, 'getOrderCategories.data', []), ({ idCategory: value, description: label }) => {
    return {
        label: `${value} - ${label}`,
        value
    };
});

const Header = ({ collapsed, onClick }) => (
    <a
        href='#'
        onClick={() => onClick(!collapsed)}
        className={classNames('drawer-header', { 'collapsed': collapsed })}
        style={{ padding: '45px 15px 0 15px' }}
    >
        <Icon name='filters' right={5} style={{ lineHeight: 1.5 }} />
        <ConditionalRender condition={!collapsed}>
            <Text text='Filtrar por:' />
        </ConditionalRender>
    </a>
);

const Wrapper = ({ isMobile, reseting, children }) => {
    const [collapsed, setCollapsed] = useState(true);

    if (isMobile) {
        return (
            <ConditionalRender condition={!reseting}>
                { children }
            </ConditionalRender>
        );
    };
    return (
        <InnerAside closedWidth='40px' background='white' closed={collapsed}>
            <InnerAsideContent>
                <FlexContainer direction='column' minHeight='740px'>
                    <Header collapsed={collapsed} onClick={setCollapsed} />
                    <ConditionalRender condition={!collapsed && !reseting}>
                        { children }
                    </ConditionalRender>
                </FlexContainer>
            </InnerAsideContent>
        </InnerAside>
    );
};

const LeftFilters = ({
    userSalesChannel,
    defaultShippingETA,
    defaultSla,
    defaultStatus,
    defaultCompanyGroup,
    defaultSalesChannel,
    sessionSalesChannel,
    salesChannel,
    category,
    allCategoryOptions,
    datePickerCheckboxes,
    onChangeDatePickerCheckbox,
    onChangeCreationDate,
    onChangeShippingETA,
    onChangeSalesChannel,
    onChangeCategory,
    selectedSla,
    onChangeSelectedSla,
    status,
    onChangeStatus,
    shopper,
    onChangeShopper,
    orderType,
    onChangeOrderType,
    defaultAtrasado,
    onChangeAtrasado,
    defaultPrioritaria,
    onChangePrioritaria,
    reseting,
    onReset,
    onSubmit,
    onChangeSelectAll,
    isMobile
}) => {
    const [selectedCompanyGroup, onChangeSelectedCompanyGroup] = useState({});
    const slaOptions = [
        { label: 'Despacho Express', value: 'express' },
        { label: 'Retiro en Tienda', value: 'tienda' },
        { label: 'Retiro al Auto', value: 'auto' },
        { label: 'Envío a domicilio', value: 'domicilio' },
        { label: 'Despacho Especial', value: 'especial' },
        { label: 'Despacho Dinamico', value: 'dinamico' }
    ];

    const defaultSelectedSla = () => {
        if (defaultSla) return filter(slaOptions, ({ value }) => includes(defaultSla, value));
        return slaOptions;
    };

    const defaultSelectedStatus = () => {
        if (defaultStatus) {
            const splitedDefaultStatus = split(defaultStatus, '-');
            return filter(statusOptions, ({ value }) => {
                const splitedOptions = split(value, '-');
                return !isEmpty(filter(splitedDefaultStatus, status => includes(splitedOptions, status)));
            });
        }
        return statusOptions;
    };

    const userSelectFilters = {
        filters: [
            {
                field: 'salesChannels',
                value: userSalesChannel
            },
            {
                field: 'statusUser',
                value: ['0']
            }
        ]
    };

    const getDefaultCompanyGroup = () => {
        return defaultCompanyGroup
            ? { label: defaultCompanyGroup, value: defaultCompanyGroup }
            : { label: 'Jumbo', value: 'Jumbo' }
    }

    const salesChannelFilteredOptionsByKind = options => filter(options, ({ kind }) => includes(selectedCompanyGroup, kind));
    const optionsCategory = formatCategoryOptions(allCategoryOptions);

    useEffect(() => {
        onChangeSalesChannel(isEmpty(selectedCompanyGroup) ? sessionSalesChannel : salesChannelFilteredOptionsByKind(sessionSalesChannel));
    }, [selectedCompanyGroup]);

    return (
        <Wrapper isMobile={isMobile} reseting={reseting}>
            <FlexContainer padding={15} direction='column'>
                <FlexContainer>
                    <Checkbox
                        label='Entrega'
                        defaultChecked={!get(datePickerCheckboxes, 'creationDate', true)}
                        disabled={!get(datePickerCheckboxes, 'creationDate', true)}
                        onChange={value => onChangeDatePickerCheckbox(value, 'shippingETA')}
                    />
                    <Checkbox
                        label='Creación'
                        defaultChecked={!get(datePickerCheckboxes, 'shippingETA', true)}
                        disabled={!get(datePickerCheckboxes, 'shippingETA', true)}
                        onChange={value => onChangeDatePickerCheckbox(value, 'creationDate')}
                    />
                </FlexContainer>
                <FormDatePicker
                    mobile={isMobile}
                    label='Fecha de entrega'
                    defaultValue={defaultShippingETA}
                    disabled={!get(datePickerCheckboxes, 'shippingETA', true)}
                    range
                    onChange={onChangeShippingETA}
                    position='fixed'
                    portalStyle={{ top: '250px' }}
                />
                <FormDatePicker
                    mobile={isMobile}
                    label='Fecha de creación'
                    disabled={!get(datePickerCheckboxes, 'creationDate', false)}
                    defaultValue={moment().subtract(29, 'days')}
                    range
                    onChange={onChangeCreationDate}
                    position='fixed'
                    portalStyle={{ top: '320px' }}
                />
                <CompanyGroupsSelect onChange={({ value }) => {
                    onChangeSelectedCompanyGroup(value);
                }} initialValue={getDefaultCompanyGroup()} />
                <FormSelect
                    multiple
                    label='Tienda'
                    allSelected
                    defaultValue={defaultSalesChannel}
                    value={salesChannel}
                    options={salesChannelFilteredOptionsByKind(sessionSalesChannel)}
                    onChange={({ value }) => onChangeSalesChannel(value)}
                />

                
                <FormSelect
                    multiple
                    label='Categoria'
                    placeholderAllSelected='Seleccionar todas'
                    value={category}
                    options={optionsCategory}
                    onChange={({ value }) => {onChangeCategory(value) }}
                /> 

                <FormSelect
                    multiple
                    label='Servicio'
                    defaultValue={defaultSelectedSla()}
                    value={selectedSla}
                    options={slaOptions}
                    onChange={({ value }) => onChangeSelectedSla(value)}
                />
                <FormSelect
                    multiple
                    label='Estado'
                    defaultValue={defaultSelectedStatus()}
                    value={status}
                    options={statusOptions}
                    onChange={({ value }) => onChangeStatus(value)}
                />
                <Checkbox
                    label='Atrasadas'
                    defaultChecked={defaultAtrasado}
                    onChange={onChangeAtrasado}
                />
                <Checkbox
                    label='Prioritarias'
                    defaultChecked={defaultPrioritaria}
                    onChange={onChangePrioritaria}
                />
                <FormSelect
                    multiple
                    label='Tipo de pedido'
                    defaultValue={orderTypeOptions}
                    value={orderType}
                    options={orderTypeOptions}
                    onChange={({ value }) => {
                        onChangeOrderType(value)
                    }}
                />
                      
                
                            
                <MobileWrapper hide showDesktop>
                    <UserSearchSelect
                        label='Shopper'
                        filters={userSelectFilters}
                        value={shopper}
                        onChange={({ value }) => onChangeShopper(value)}
                        placeholder='Ingrese (nombre, apellido o email)'
                        fromUserSelect
                        onChangeSelectAll={({ value }) => onChangeSelectAll(value)}
                    />
                </MobileWrapper>
            </FlexContainer>
            <FlexContainer pX={15}>
                <Button
                    link
                    text='Limpiar'
                    onClick={onReset}
                />
                <Button
                    secondary
                    text='Aplicar'
                    onClick={onSubmit}
                />
            </FlexContainer>
        </Wrapper>
    );
};

Header.propTypes = {
    collapsed: bool,
    onClick: func
};

Header.defaultProps = {
    collapsed: true,
    onClick: () => {}
};

LeftFilters.propTypes = {
    userSalesChannel: array,
    defaultShippingETA: array,
    defaultSla: object,
    defaultStatus: oneOfType([string, object]),
    defaultCompanyGroup: string,
    sessionSalesChannel: array,
    defaultSalesChannel: array,
    salesChannel: array,
    category: array,
    allCategoryOptions: array,
    datePickerCheckboxes: object,
    onChangeDatePickerCheckbox: func,
    onChangeCreationDate: func,
    onChangeShippingETA: func,
    onChangeSalesChannel: func,
    onChangeCategory: func,
    selectedSla: oneOfType([array, arrayOf(object)]),
    onChangeSelectedSla: func,
    status: oneOfType([array, arrayOf(object)]),
    onChangeStatus: func,
    onChangeOrderType: func,
    orderType: oneOfType([array, arrayOf(object)]),
    defaultAtrasado: bool,
    onChangeAtrasado: func,
    defaultPrioritaria: bool,
    onChangePrioritaria: func,
    reseting: bool,
    onReset: func,
    onSubmit: func,
    onChangeSelectAll: func,
    onChangeTest: func
};

LeftFilters.defaultProps = {
    userSalesChannel: [],
    datePickerCheckboxes: { shippingETA: true, creationDate: false },
    onChangeDatePickerCheckbox: () => {},
    onChangeCreationDate: () => {},
    onChangeShippingETA: () => {},
    onChangeSalesChannel: () => {},
    selectedSla: [],
    onChangeSelectedSla: () => {},
    onChangeOrderType: () => {},
    status: [],
    defaultAtrasado: false,
    onChangeAtrasado: () => {},
    defaultPrioritaria: false,
    onChangePrioritaria: () => {},
    reseting: false,
    onReset: () => {},
    onSubmit: () => {},
    onChangeSelectAll: () => {}
};

export default LeftFilters;
